export default __webpack_public_path__ + "static/media/manjuPanda.a452af06.webp";